import { GraphicsMaterials } from 'src/app/digital-twin/graphics/graphics-materials';
import * as THREE from '@phdsoft/three';
import { Injectable } from '@angular/core';
import { Util } from '@phdsoft/common';

@Injectable({ providedIn: "root" })
export class PointsRender {

    constructor() { }

    public returnBox(position, width: number = 1, heigth: number = 1, depth: number = 1) {
        var newGeometry = new THREE.BoxGeometry(width, heigth, depth)

        var box = new THREE.Mesh(newGeometry, GraphicsMaterials.criticalAreaBoxMaterial);
        box.position.copy(position)

        return box;
    }

    public returnSpherePoint(position, radius: number = 0.51, widthSegments: number = 0.51, heightSegments: number = 0.51) {
        var newGeometry = new THREE.SphereGeometry(radius, widthSegments, heightSegments)

        var sphere = new THREE.Mesh(newGeometry, GraphicsMaterials.criticalAreaBoxMaterial);
        sphere.position.copy(position)

        return sphere;
    }

    public returnPlatePoint(position, plate, normal: any, subPosition?, box?: THREE.Box3) {
        // var normalReturned: THREE.Vector3;
        var pointShape = new THREE.Shape()
            .moveTo(-1, -2)
            .lineTo(-1, 2)
            .lineTo(2, 0)
            .lineTo(-1, -2);
        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 0, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );
        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }

        for (let i = 0; i < extrudedGeometry.faces.length / 2; i++) {
            faces.push(extrudedGeometry.faces[i].a)
            faces.push(extrudedGeometry.faces[i].b)
            faces.push(extrudedGeometry.faces[i].c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();

        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);
        // normalReturned = new THREE.Vector3(normal[0], normal[1], normal[2]);

        const canonicalAxis = Util.LargestCanonicalAxis(normal);
        let scale = 2;
        let size = new THREE.Vector3();
        size = box.getSize(size);
        let scalar = 0.01;
        const area = Util.getAreaFromBBWithNormal(size, normal);

        {
            scale = 2;
        }

        _point.position.copy(position);
        _point.scale.set(0.0251 * scale, 0.031 * scale, 0.031 * scale);

        if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
            _point.rotateX(1.5708)
        }
        else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
            _point.rotateY(-1.5708)
        }

        if (Math.abs(normal.x) > Math.abs(normal.y) && Math.abs(normal.x) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }
        else if (Math.abs(normal.y) > Math.abs(normal.x) && Math.abs(normal.y) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }

        position.add(normal);
        _point.lookAt(position);

        return _point;
    }

    public returnIconPoint(position, plate, normal: THREE.Vector3, subPosition?, box?: THREE.Box3) {
        var pointShape = new THREE.Shape()
            .moveTo(-3, -1)
            .lineTo(-3, 1)
            .lineTo(3, 1)
            .lineTo(3, -1)
            .lineTo(-3, -1);

        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 1, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );

        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }

        for (const i of extrudedGeometry.faces) {
            faces.push(i.a)
            faces.push(i.b)
            faces.push(i.c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();

        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);
        normal = new THREE.Vector3(normal.x, normal.y, normal.z)
        const canonicalAxis = Util.LargestCanonicalAxis(normal);

        let scale = 2;
        let size = new THREE.Vector3();
        size = box.getSize(size);
        let scalar = 0.01;
        const area = Util.getAreaFromBBWithNormal(size, normal);

        {
            scale = 2;
        }

        _point.position.copy(position);
        _point.scale.set(0.0251 * scale, 0.031 * scale, 0.031 * scale);
        if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
            _point.rotateX(1.5708)
        }
        else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
            _point.rotateY(-1.5708)
        }

        if (Math.abs(normal.x) > Math.abs(normal.y) && Math.abs(normal.x) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }
        else if (Math.abs(normal.y) > Math.abs(normal.x) && Math.abs(normal.y) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }

        return _point;
    }

    public returnWebPoint(position, plate, normal, subPosition?) {
        var pointShape = new THREE.Shape()
            .moveTo(-0.5, -3.5)
            .lineTo(-0.5, -2)
            .lineTo(-2, -2)
            .lineTo(-2, 2)
            .lineTo(-0.5, 2)
            .lineTo(-0.5, 3.5)
            .lineTo(0.5, 3.5)
            .lineTo(0.5, 2)
            .lineTo(2, 2)
            .lineTo(2, -2)
            .lineTo(0.5, -2)
            .lineTo(0.5, -3.5)
            .lineTo(-0.5, -3.5);
        var geometry = new THREE.ShapeGeometry(pointShape);
        // geometry.
        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 0, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );
        // geometry.

        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }
        for (let i = 0; i < extrudedGeometry.faces.length / 2; i++) {
            faces.push(extrudedGeometry.faces[i].a)
            faces.push(extrudedGeometry.faces[i].b)
            faces.push(extrudedGeometry.faces[i].c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();

        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);

        const canonicalAxis = Util.LargestCanonicalAxis(normal);

        _point.position.copy(position);
        _point.scale.set(0.0251, 0.031, 0.031);

        let lookAt: THREE.Vector3 = (position as THREE.Vector3).clone().add(normal.clone())
        _point.lookAt(lookAt)
        // if (canonicalAxis === 'PositiveZ' || canonicalAxis === 'NegativeZ') {
        //     _point.rotateY(0)
        // }
        // else if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
        //     _point.rotateX(1.5708)
        // }
        // else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
        //     _point.rotateY(-1.5708)
        // }
        // if (Math.abs(normal.x) > Math.abs(normal.y) && Math.abs(normal.x) > Math.abs(normal.z)) {
        //     _point.rotation.z = -Math.PI / 2;
        // }
        // else if (Math.abs(normal.y) > Math.abs(normal.x) && Math.abs(normal.y) > Math.abs(normal.z)) {
        //     _point.rotation.z = -Math.PI / 2;
        // }

        return _point;
    }

    public returnFlangePoint(position, plate, normal, subPosition?) {
        var pointShape = new THREE.Shape()
            .moveTo(-2, -2)
            .lineTo(-2, 1)
            .lineTo(-3.5, 1)
            .lineTo(-3.5, 2)
            .lineTo(3.5, 2)
            .lineTo(3.5, 1)
            .lineTo(2, 1)
            .lineTo(2, -2)
            .lineTo(-2, -2);
        var geometry = new THREE.ShapeGeometry(pointShape);
        // geometry.
        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 0, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );
        // geometry.
        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }

        for (let i = 0; i < extrudedGeometry.faces.length / 2; i++) {
            faces.push(extrudedGeometry.faces[i].a)
            faces.push(extrudedGeometry.faces[i].b)
            faces.push(extrudedGeometry.faces[i].c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();

        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);

        const canonicalAxis = Util.LargestCanonicalAxis(normal);

        _point.position.copy(position);
        _point.scale.set(0.0251, 0.031, 0.031);

        let lookAt: THREE.Vector3 = (position as THREE.Vector3).clone().add(normal.clone())
        _point.lookAt(lookAt)

        // if (canonicalAxis === 'PositiveZ' || canonicalAxis === 'NegativeZ') {
        //     _point.rotateY(0)
        // }
        // else if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
        //     _point.rotateX(1.5708)
        // }
        // else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
        //     _point.rotateY(-1.5708)
        // }
        // if (Math.abs(normal.x) > Math.abs(normal.y) && Math.abs(normal.x) > Math.abs(normal.z)) {
        //     _point.rotation.z = -Math.PI / 2;
        // }
        // else if (Math.abs(normal.y) > Math.abs(normal.x) && Math.abs(normal.y) > Math.abs(normal.z)) {
        //     _point.rotation.z = -Math.PI / 2;
        // }

        return _point;
    }

    public returnFacePlatePoint(position, plate, normal, subPosition?) {
        var pointShape = new THREE.Shape()
            .moveTo(-2, -2)
            .lineTo(-2, 2)
            .lineTo(2, 2)
            .lineTo(2, -2)
            .lineTo(-2, -2);
        var geometry = new THREE.ShapeGeometry(pointShape);
        // geometry.
        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 0, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );

        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }

        for (let i = 0; i < extrudedGeometry.faces.length / 2; i++) {
            faces.push(extrudedGeometry.faces[i].a)
            faces.push(extrudedGeometry.faces[i].b)
            faces.push(extrudedGeometry.faces[i].c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();
        // geometry.
        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);

        // const canonicalAxis = Util.LargestCanonicalAxis(normal);

        _point.position.copy(position);
        _point.scale.set(0.0251, 0.031, 0.031);

        let lookAt: THREE.Vector3 = (position as THREE.Vector3).clone().add(normal.clone())
        _point.lookAt(lookAt)

        // if (canonicalAxis === 'PositiveZ' || canonicalAxis === 'NegativeZ') {
        //     _point.rotateY(0)
        // }
        // else if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
        //     _point.rotateX(1.5708)
        // }
        // else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
        //     _point.rotateY(-1.5708)
        // }

        return _point;
    }

    public returnBeamPartPoint(position, plate, normal: THREE.Vector3, subPosition?, box?: THREE.Box3) {
        var pointShape = new THREE.Shape()
            .moveTo(-1, -2)
            .lineTo(-1, 2)
            .lineTo(2, 0)
            .lineTo(-1, -2);

        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 1, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );

        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }

        for (const i of extrudedGeometry.faces) {
            faces.push(i.a)
            faces.push(i.b)
            faces.push(i.c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();
        // geometry.
        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);
        normal = new THREE.Vector3(normal.x, normal.y, normal.z)

        const canonicalAxis = Util.LargestCanonicalAxis(normal);
        let scale = 2;
        let size = new THREE.Vector3();
        size = box.getSize(size);
        let scalar = 0.01;
        const area = Util.getAreaFromBBWithNormal(size, normal);

        {
            scale = 2;
        }

        _point.position.copy(position);
        _point.scale.set(0.0251 * scale, 0.031 * scale, 0.031 * scale);

        if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
            _point.rotateX(1.5708)
        }
        else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
            _point.rotateY(-1.5708)
        }

        if (Math.abs(normal.x) > Math.abs(normal.y) && Math.abs(normal.x) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }
        else if (Math.abs(normal.y) > Math.abs(normal.x) && Math.abs(normal.y) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }

        return _point;
    }

    public returnCablePoint(position, plate, normal: THREE.Vector3, subPosition?, box?: THREE.Box3) {
        var pointShape = new THREE.Shape()
            .moveTo(-1, -2)
            .lineTo(-1, 2)
            .lineTo(2, 0)
            .lineTo(-1, -2);

        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 1, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );

        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }

        for (const i of extrudedGeometry.faces) {
            faces.push(i.a)
            faces.push(i.b)
            faces.push(i.c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();
        // geometry.
        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);
        normal = new THREE.Vector3(normal.x, normal.y, normal.z)

        const canonicalAxis = Util.LargestCanonicalAxis(normal);
        let scale = 2;
        let size = new THREE.Vector3();
        size = box.getSize(size);
        let scalar = 0.01;
        const area = Util.getAreaFromBBWithNormal(size, normal);
        {
            scale = 2;
        }

        _point.position.copy(position);
        _point.scale.set(0.0251 * scale, 0.031 * scale, 0.031 * scale);
        if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
            _point.rotateX(1.5708)
        }
        else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
            _point.rotateY(-1.5708)
        }

        if (Math.abs(normal.x) > Math.abs(normal.y) && Math.abs(normal.x) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }
        else if (Math.abs(normal.y) > Math.abs(normal.x) && Math.abs(normal.y) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }

        return _point;
    }

    public returnPipePoint(position: THREE.Vector3, normal: THREE.Vector3, diameter: number) {
        var pointShape = new THREE.Shape()
            .moveTo(-1, -2)
            .lineTo(-1, 2)
            .lineTo(2, 0)
            .lineTo(-1, -2);
        var extrudeOptions: THREE.ExtrudeGeometryOptions = { depth: 0, bevelEnabled: false };
        var extrudedGeometry = new THREE.Geometry().fromBufferGeometry(
            new THREE.ExtrudeGeometry(pointShape, extrudeOptions),
        );

        const newGeometry = new THREE.BufferGeometry();

        const vertices = [];
        const faces = [];
        for (const v of extrudedGeometry.vertices) {
            vertices.push(v.x)
            vertices.push(v.y)
            vertices.push(v.z)
        }

        for (let i = 0; i < extrudedGeometry.faces.length / 2; i++) {
            faces.push(extrudedGeometry.faces[i].a)
            faces.push(extrudedGeometry.faces[i].b)
            faces.push(extrudedGeometry.faces[i].c)
        }
        newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
        newGeometry.setIndex(faces);
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();

        var _point = new THREE.Mesh(newGeometry, GraphicsMaterials.pointMaterial);
        // normalReturned = new THREE.Vector3(normal[0], normal[1], normal[2]);

        const canonicalAxis = Util.LargestCanonicalAxis(normal);
        let scale = 2;
        let scalar = 0.003;

        scale = diameter * scalar;

        _point.position.copy(position);
        _point.scale.set(0.0251 * scale, 0.031 * scale, 0.031 * scale);

        if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
            _point.rotateX(1.5708)
        }
        else if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
            _point.rotateY(-1.5708)
        }

        if (Math.abs(normal.x) > Math.abs(normal.y) && Math.abs(normal.x) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }
        else if (Math.abs(normal.y) > Math.abs(normal.x) && Math.abs(normal.y) > Math.abs(normal.z)) {
            _point.rotation.z = -Math.PI / 2;
        }

        position.add(normal);
        _point.lookAt(position);

        return _point;
    }
}

class PointShape {
    private _PlateShape = new THREE.ShapeGeometry(new THREE.Shape()
        .moveTo(-1, -2)
        .lineTo(-1, 2)
        .lineTo(2, 0)
        .lineTo(-1, -2));

    private _WebPointShape = new THREE.ShapeGeometry(new THREE.Shape()
        .moveTo(-0.5, -3.5)
        .lineTo(-0.5, -2)
        .lineTo(-2, -2)
        .lineTo(-2, 2)
        .lineTo(-0.5, 2)
        .lineTo(-0.5, 3.5)
        .lineTo(0.5, 3.5)
        .lineTo(0.5, 2)
        .lineTo(2, 2)
        .lineTo(2, -2)
        .lineTo(0.5, -2)
        .lineTo(0.5, -3.5)
        .lineTo(-0.5, -3.5));

    private _FlangePointShape = new THREE.ShapeGeometry(new THREE.Shape()
        .moveTo(-2, -2)
        .lineTo(-2, 1)
        .lineTo(-3.5, 1)
        .lineTo(-3.5, 2)
        .lineTo(3.5, 2)
        .lineTo(3.5, 1)
        .lineTo(2, 1)
        .lineTo(2, -2)
        .lineTo(-2, -2));

    private _FacePlatePointShape = new THREE.ShapeGeometry(new THREE.Shape()
        .moveTo(-2, -2)
        .lineTo(-2, 2)
        .lineTo(2, 2)
        .lineTo(2, -2)
        .lineTo(-2, -2));

    public PlateShape() {
        return this._PlateShape;
    }

    public WebPointShape() {
        return this._WebPointShape
    }

    public FlangePointShape() {
        return this._FlangePointShape
    }

    public FacePlatePointShape() {
        return this._FacePlatePointShape
    }
}
